var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKey4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.438 0a4.57 4.57 0 0 0-4.563 4.563c0 1.056.36 2.029.965 2.802L1.165 14.04a.561.561 0 1 0 .796.795l.54-.54 1.54 1.54a.56.56 0 0 0 .796 0 .56.56 0 0 0 0-.795l-1.54-1.54 1.204-1.204 1.54 1.54a.56.56 0 0 0 .796 0 .56.56 0 0 0 0-.795l-1.54-1.54 3.34-3.34a4.54 4.54 0 0 0 2.802.965c2.516 0 4.562-2.047 4.562-4.563S13.954 0 11.438 0m0 8C9.543 8 8 6.458 8 4.562s1.542-3.438 3.438-3.438 3.438 1.542 3.438 3.438S13.334 8 11.438 8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKey4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/key4.svg";